import { N as f } from "../chunks/NcActionInput-Vdsm4Jt5.mjs";
export {
  f as default
};
